import { gmiRequest } from 'actions/request';
import actions from '@ehi/global-marketing-interface/lib/actions';
import services from '@ehi/global-marketing-interface/lib/services';

export const addAdditionalDriversOnReservation = (payload) => (dispatch) =>
  dispatch(
    gmiRequest({
      action: actions.request({
        service: services.gma.reservations.addAdditionalDrivers,
        data: { payload },
      }),
      loadingOverlay: true,
    })
  );
